import * as React from 'react';
import { Layout as AntLayout } from 'antd';
import { useAppToken } from 'src/style';
import { Outlet } from 'react-router-dom';
import { Banner } from './banner';
import { isMobile } from 'src/services/utils';

const { Content } = AntLayout;

export const LayoutWorkspace = () => {
    const {
        token: { colorBgContainer }
    } = useAppToken();

    return <AntLayout style={isMobile ? {} : { height: '100vh' }}>
        {!isMobile && <Banner />}
        <Content className='site-layout' style={isMobile ? {} : { padding: '10px 25px', height: '100%' }}>
            <div style={{ borderRadius: 8, padding: 24, background: colorBgContainer, height: '100%' }}>
                <Outlet />
            </div>
        </Content>
    </AntLayout>;
};
